import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['ru', 'en', 'az'],
  /** Used when Accept-Language does not match any `locales`; also for next-intl middleware fallback. */
  defaultLocale: 'en',
  localePrefix: 'always',
  localeDetection: true,
});
